import {
  HTTP_INTERCEPTORS,
  HttpBackend,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  PreloadAllModules,
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { NgxStripeModule } from 'ngx-stripe';
import { AppComponent } from './app/app.component';
import { initTranslationsFactory } from './app/app.translations';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

import { HttpErrorInterceptorService } from 'src/lib/lib-ngx/services/http-error-interceptor.service';
import { APP_TOKEN, appInitializerFn } from './lib/lib-ngx/services/AppInitializerFn';
import { ConfigService } from './lib/lib-ngx/services/config.service';
import { VersionService } from './lib/lib-ngx/services/version.service';
import { HttpInterceptorVersionService } from './lib/lib-ngx/services/http-interceptor-version.service';

import packageJson from '../package.json';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

export function createTranslateLoader(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/', suffix: '.json?cb=' + new Date().getTime() },
    { prefix: './assets/lib-ngx/i18n/', suffix: '.json?cb=' + new Date().getTime() },
  ]);
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      toastDuration: 2000,
      innerHTMLTemplatesEnabled: true,
    }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true,
    },
    {
      provide: APP_TOKEN,
      useValue: { name: packageJson.name, version: packageJson.version },
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [ConfigService, VersionService, APP_TOKEN],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslationsFactory,
      multi: true,
      deps: [TranslateService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorVersionService,
      multi: true,
    },
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'fr',
        useDefaultLang: false, // will show translation key if no translation is found
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpBackend],
        },
      }),
      NgxStripeModule.forRoot(environment.stripe.publicKey)
    ),
    { provide: 'googleTagManagerId', useValue: environment.gtm },
  ],
});
